module.exports = "/_next/static/images/5ace5f0a9f206dc6eff8556935293cf2-defer-xs.png.webp";